import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import BreadcrumbStyles from '@/components/SupportSection/shared/SupportBreadcrumbs/BreadcrumbStyles'

const BreadcrumbsNav = ({ noPadding, breadcrumb = '' }) => {
  const [route, setRoute] = useState('');
  const router = useRouter();

  useEffect(() => {
    if (breadcrumb) {
      setRoute(breadcrumb);
    } else {
      const routeArray = router.route.split('/');
      const slug = routeArray[routeArray.length - 1];
      if (slug.includes('-')) {
        // remove the dash and capitalize all letters as a part of the slug
        const slugArray = slug.split('-');
        const newSlugArray = slugArray.map(ele => {
          return ele.charAt(0).toUpperCase() + ele.slice(1);
        })
        const newSlug = newSlugArray.join(' ');
        setRoute(newSlug);
      } else {
        const formattedSlug = slug.charAt(0).toUpperCase() + slug.slice(1);
        setRoute(formattedSlug);
      }
    }
  }, [breadcrumb]);

  const toggleSearchBar = (active) => {
    if (active) {
      document.getElementById('support-search-bar').classList.add('active')
      document.querySelector("#support-search-bar input").focus()
    } else {
      document.getElementById('support-search-bar').classList.remove('active')
    }
  }

  return (
    <BreadcrumbStyles noPadding={noPadding}>
      <div className="breadcrumb-container">
        <ul className="breadcrumbs desktop">
          <li className="support">
            <a href="/support">Support</a>
          </li>
          <li className="route">{route}</li>
        </ul>
        <div className="breadcrumbs mobile">
          <div className="title-container">
            <Link href="/support">
              <img className="back-btn" src="/icons/arrow-left-3.svg" />
            </Link>
            <div className="route-title">
              {route}
            </div>
          </div>
          <div className="search">
            <img className="search-btn" src="/icons/search-3.svg" onClick={() => toggleSearchBar(true)} />
          </div>
        </div>
      </div>
    </BreadcrumbStyles>
  );
};

export default BreadcrumbsNav;